import { Component, Inject, OnInit } from '@angular/core';
import { projectActions } from '@src/store/reducers/projectReducer';
import { Store } from '@src/store';
import { cloneDeep } from 'lodash';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { DialogManagerService } from '@src/services';
import { projectsActions } from '@src/store/reducers/projectsReducer';


@Component({
    selector: 'static-content',
    template: require('./static-content.component.html'),
    styles: [require('./static-content.component.scss')]
})
export class StaticContentComponent implements OnInit {
    private readonly projectId: number;
    public dbFlags:any = null;
    public displayedColumns: any = [
        { name: 'DB Name', type: 'Combobox' }, { name: 'Table Name', type: 'Autocomplete', key:'TableName', elementList:'ValidTableNames' },
        {name:'Unique Index', type:'Autocomplete', key:'UniqueIndex', elementList:'ValidIndexNames' }];

    public dataSource: any;
    public dataSourceTmp: any;
    public tmpDataSource: any;
    public translations;
    public newRow: any = {
        dBCId: 0,
        dbName: '',
        tableName: '',
        uniqueIndexName: ''
    };
    private rmSchemas: Array<any> = new Array();
    //private rmSchemasExtended: any;
    private schemasTablesWithUIndexes: Map<number, Array<string>> = new Map();
    
    private whileLoading:boolean = true;
    //private schemasTablesUIndexes: Map<string, Array<string>>;


    constructor(private store: Store, @Inject('$state') private state: any, @Inject('dbTypeService') private dbTypeService: any,
                private translatePipe: TranslatePipe,
                private dialogManagerService: DialogManagerService) 
    {
        this.projectId = this.state.params.id;        
    }
    
    private async loadTablesAndIndexes(dbcid: number)
    {
        //temp loading of tables and indexes data
        this.store.dispatch(
            { type: 'GET_DATABASE_TABLES_AND_U_INDEXES', payload: { projectId: this.projectId, dbcid: dbcid } }).
            then((resultAction) => {
                // Check if the action was fulfilled
                if(resultAction)
                    this.schemasTablesWithUIndexes.set(dbcid, resultAction);
                
                this.whileLoading = false;
              })
              .catch((error) => {
                console.error('Unexpected Error:', error); // Handle unexpected errors
              });
                
        
    }


    public async ngOnInit() {
        this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']).then(value => this.translations = value);
        const apiRequests = async (action: any) => await this.store.dispatch(
            { type: action, payload: { projectId: this.projectId } }
        );
        const projectsState = await this.store.getState().projects;            
        //oleg changed === to == need to fix later
        if(!projectsState.projectWithMetaData){
            var GetAllData = await this.store.dispatch(
                { type: projectsActions.GET_PROJECT_META_DATA, payload: { projId: this.projectId } }
            );
            if(GetAllData && GetAllData.data){
                projectsState.projectWithMetaData = GetAllData.data;
            }
        }
        if (projectsState && projectsState.projectWithMetaData)
        {
            const tempDbTypeId = projectsState.projectWithMetaData.dbTypeId;
            this.dbFlags = await this.dbTypeService.getFlags(tempDbTypeId);
            if(this.dbFlags.HasDevEnv == true){
                ;             
            }
            if(this.dbFlags.HasValidate == true){
                ;
            }
        }
        
        
        let extSchemas = await apiRequests(projectActions.GET_RM_SCHEMAS_EXTENDED);
        
        const parsedData: ParsedData = extSchemas;
        for (const key of Object.keys(parsedData)) {
            
            if(!parsedData[key].isSuperUser)
                this.rmSchemas.push({'key':Number.parseInt(key), 'data':parsedData[key].name})
                this.loadTablesAndIndexes(Number.parseInt(key));
          }
        
        
        this.dataSourceTmp = await apiRequests(projectActions.GET_STATIC_CONTENT);
        
        

        this.dataSourceTmp.map((item) => {
            const dbName = this.rmSchemas.find(val => val.id === item.dBCId);
            item.dbName = (dbName) ? dbName.data : item.dBCId;
            
        });        
       
        this.dataSource = this.dataSourceTmp;
        
        this.displayedColumns.map((item) => {
            if (item.name === 'DB Name') {
                item.list = this.rmSchemas.map(a => a.data);
                item.placeholder = 'Choose DB Name';
            }
            if (item.name === 'Table Name') {
                //item.list = this.rmSchemas.map(a => a.data);
                item.placeholder = 'Choose Table';
            }
            if (item.name === 'Unique Index') {
                //item.list = this.rmSchemas.map(a => a.data);
                item.placeholder = 'Choose Unique Index';
            }
           
           
        });

        //keep backup for cancel
        this.tmpDataSource = cloneDeep(this.dataSource);
    }

    public save(): void {
        this.dataSourceTmp = cloneDeep(this.dataSource);
        
        this.store.dispatch({
            type: projectActions.UPDATE_STATIC_CONTENT,
            payload: { projectId: this.projectId, staticContent: this.dataSourceTmp }
        })
            .then((data: any) => {
                if (data) {
                    this.tmpDataSource = cloneDeep(this.dataSource);
                    this.dialogManagerService.showSuccessDialog({ title: '', text: '' });
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: this.translations['ERROR'], 
                        text: this.translations['UNEXPECTED_ERROR']
                    });
                }
            });
    }

    public cancel(): void {
        this.dataSource = cloneDeep(this.tmpDataSource);
    }

    public selectValue(value): void {
        const { event, element, item } = value;
        if (item.name === 'DB Name') {
            const rmSchema = this.rmSchemas.find(v => v.data === event);
            element.dBCId = rmSchema.key;

            //clear select table name (exxcept for in initial load)            
            if(!this.whileLoading)
            {
                element.TableName = '';
                element.UniqueIndex = '';
            }

            //update valid table names - filter tables that are already in use
            var temp = this.schemasTablesWithUIndexes.get(element.dBCId);
            let tables: string[] = [];
            //console.log(this.dataSource);
            temp?.forEach(
                tableLine => 
                    {
                        if(!this.dataSource.some(item => item.name === tableLine['TableName']))
                            tables.push(tableLine['TableName'])
                    }
            );
                        
            element['ValidTableNames'] = tables;

            
            //element['ValidTableNames'] = this.schemasTables.get(element.dBCId);
            
        }
        else if(item.name == "Table Name")
        {
            //update valida index names
            var temp = this.schemasTablesWithUIndexes.get(element.dBCId);
            
            let indexes: string[] = [];
            indexes = temp?.filter(line => line['TableName'] == value.data.name)[0]['Indexes'];

            element['ValidIndexNames'] = indexes; 
            //clear select index name (exxcept for in initial load)
            if(!this.whileLoading)
                element.UniqueIndex = '';
            //var fieldName = element.dBCId.toString() + "-" + value.data.name;
            //element['ValidIndexNames'] = this.schemasTablesUIndexes.get(fieldName);
        }
        
    }

    public addNewRow(row): void {
        const keys = Object.keys(row);
        if (!keys) {
            return;
        }
        const newRow  = cloneDeep(this.newRow);
        keys.forEach((key) => {
            newRow[key] = row[key];
            if (key === 'dbName') {
                const rmSchema = this.rmSchemas.find(v => v.data === row[key]);
                newRow.dBCId = rmSchema.key;
            }          
        });
        this.dataSource.push(newRow);
    }

    public removeRow(element: any): void {
        this.dataSource.splice(this.dataSource.indexOf(element), 1);
    }

}

type ConnectionProperties = {
    host: string;
    authType: string;
    userName: string;
    dbName: string;
    password: string;
    vaultId: number;
    vaultConfiguration: any;
    vaultConfigurationString: any;
    additionalOptions: any[];
  };
  
  type ParsedDataItem = {
    id: number;
    name: string;
    envId: number;
    envName: string | null;
    hostName: string;
    connectionProperties: ConnectionProperties;
    dbId: number;
    parentId: number | null;
    isSuperUser: boolean;
    isManaged: boolean;
    schemaMap: any;
    lastModifiedDate: string;
  };
  
  type ParsedData = {
    [key: string]: ParsedDataItem;
  };
  


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/project/static-content/static-content.component.ts